import React from 'react';
import * as Yup from 'yup';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import CustomTextField from '../../components/forms/CustomTextField';
import { colors } from '../../assets/utils/colors';

// ################### validation schema ###############
const addBranchStockSchema = Yup.object({
    product_quantity: Yup.string().required('Product quantity is required'),
});

const AddBranchStock = () => {
    return (
        <>
            <Formik
                initialValues={{
                    product_quantity: '',
                }}
                validationSchema={addBranchStockSchema}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={12}>
                                <Box sx={{ display: 'flex' }}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                            p: 1,
                                            border: `1px solid ${colors.bgColor3}`,
                                        }}
                                    >
                                        <Typography sx={{ fontWeight: 'bold' }}>
                                            In-stock
                                        </Typography>
                                        <Typography>500</Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                            p: 1,
                                            border: `1px solid ${colors.bgColor3}`,
                                        }}
                                    >
                                        <Typography sx={{ fontWeight: 'bold' }}>
                                            Sold
                                        </Typography>
                                        <Typography>500</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="product_quantity"
                                    label={'Add stock quantity'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                        onClick={formik.handleSubmit}
                                    >
                                        Add stock quantity
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default AddBranchStock;
